var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgHouse(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.333 31.55L2.57 33.558A1.067 1.067 0 011 32.617v-8.79c0-.39.213-.749.555-.936l38.965-21.3a1 1 0 01.96 0l38.965 21.3c.342.187.555.546.555.936v8.79c0 .805-.858 1.32-1.569.941l-3.764-2.008m-69.334 0L40.53 13.312a1 1 0 01.942 0L75.667 31.55m-69.334 0v48.178c0 .59.478 1.067 1.067 1.067H41M75.667 31.55v48.178c0 .59-.478 1.067-1.067 1.067H41m0 0v-11.2",
    stroke: "#504FE9",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.134 49.862c0 4.124-8.357 7.466-18.667 7.466-10.309 0-18.666-3.342-18.666-7.466m37.333-11.2c0 3.829-8.357 6.933-18.667 6.933-10.309 0-18.666-3.104-18.666-6.933m37.333 0c0-3.83-8.357-6.933-18.667-6.933-10.309 0-18.666 3.104-18.666 6.933m37.333 0v22.4c0 5.007-8.357 9.067-18.667 9.067-10.309 0-18.666-4.06-18.666-9.067v-22.4",
    stroke: "#504FE9",
    strokeWidth: 2
  })));
}
export default SvgHouse;